import React, { useEffect, useState } from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import ExperimentsList from '../../Components/BodyComponent/Experiments/ExperimentsList';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SkeletonComponent from '../../Components/SkeletonComponent';
import { experimentsService } from '../../Services/Experiments.services';
import { Header } from '../../Components/Shared/Header/Header';

function ExperimentsPage() {
    const { isAdmin } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [experiments, setExperiments] = useState([]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const data = await experimentsService.getAllExperiments();
            setExperiments(data);
        } catch (err) {
            console.error('Error fetching experiments:', err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleAddNewExperiment = async () => {
        try {
            const newExperiment = await experimentsService.createExperiment();

            if (newExperiment?.id) {
                await experimentsService.getExperiment(newExperiment.id);
                navigate(`/experiments/${newExperiment.id}/docs`);
            }
        } catch (error) {
            console.error('Error creating experiment:', error);
        }
    };

    return (
        <Grid item xs={12} sm={12} md={12} sx={{ mt: 2, mb: 2 }}>
            <Card component={Paper}>
                <CardContent>
                    <div className="header">
                        <Header
                            title="Experiments"
                            actionButtons={[
                                isAdmin && (
                                    <Button
                                        key="add-experiment-button"
                                        variant="contained"
                                        sx={{ ml: 2 }}
                                        onClick={handleAddNewExperiment}
                                    >
                                        Add Experiment
                                    </Button>
                                ),
                            ]}
                        />
                    </div>
                    {isLoading ? (
                        <SkeletonComponent />
                    ) : (
                        <ExperimentsList
                            experiments={experiments}
                            onExperimentDeleted={fetchData}
                        />
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
}

export default ExperimentsPage;
